import { ReactNode } from 'react';

/**
 * * 작품 관리 관련 타입 모음
 */

export const DefaultInputCountConfig: IInputCountConifg = {
  max: 30,

  show: true,
};

export interface IInputCountConifg {
  // Max character count. Different from the native `maxLength`, it will be marked warning but not truncated
  max?: number;
  // Custom character count, for example, the standard emoji length is greater than 1, you can customize the counting strategy to change it to 1
  strategy?: (value: string) => number;
  // Same as `showCount`
  show?:
    | boolean
    | ((args: {
        value: string;
        count: number;
        maxLength?: number;
      }) => ReactNode);
  // Custom clipping logic when the number of characters exceeds `count.max`, no clipping when not configured
  exceedFormatter?: (value: string, config: { max: number }) => string;
}

export interface IModelSlave {
  model_slave_id: number;
  file_url: string;
  file_key: string;
  file_name: string;
  is_motion: boolean;
  motion_name: string;
  sortkey: string;
  model_id: number;
}

// 캐릭터 모델 interface
export interface IModel {
  model_id: number;
  project_id: number;
  model_name: string;
  model_type: string;
  offset_x: number;
  offset_y: number;
  game_scale: number;
  lobby_offset_x: number;
  lobby_offset_y: number;
  lobby_game_scale: number;
  sortkey: number;
  direction: string;
  tall_grade: number;
  model_ver: number;
  slaves: IModelSlave[];
}

// ModelTable Visible default State
export const EmptyModelVisibleState: IModelVibileState = {
  modelRegister: false,
  modelUpdate: false,
  modelDelete: false,
  modelReset: false,
  assetsRegister: false,
  assetsUpdate: false,
  zip: false,
  name: '',
};

// ModelTable Visible State
export interface IModelVibileState {
  modelRegister: boolean;
  modelUpdate: boolean;
  modelDelete: boolean;
  modelReset: boolean;
  assetsRegister: boolean;
  assetsUpdate: boolean;
  zip: boolean;
  name: string;
}

export interface IModalVisible {
  create: boolean;
  edit: boolean;
}

// 아이템 로컬라이즈 정보
export interface IItemLocalize {
  id?: number;
  lang: string;
  item_name: string;
  updated?: boolean;
}

export const EmptyItemExtension: IItemExtension = {
  product_type: 'free',
  price: 0,
  sale_price: 0,
  sale_start_date: new Date(),
  sale_end_date: new Date('9999-12-31'),
  is_public: true,
  static_id: -1,
};

// 아이템 익스텐션 (판매정보)
export interface IItemExtension {
  id?: number;
  product_type: string;
  price: number;
  sale_price: number;
  sale_start_date: Date;
  sale_end_date: Date;
  is_public: boolean;
  static_id: number;
}

// 아이템
export interface IItem {
  id?: number;
  origin_name: string;
  item_type: string;
  project_id: number;
  is_unique: boolean;
  is_consumable: boolean;
  is_active: boolean;
  is_ability: boolean;
  icon_url: null;
  icon_key: null;
  icon_bucket: null;
  image_url: null;
  image_key: null;
  image_bucket: null;
  resource_id: number;
  is_prime: boolean;
  currency: string;
  ability_id: number;
  ability_value: number;
  localizations: IItemLocalize[];
  extension: IItemExtension | null;
}

// 의상
export const EmptyDress: IDress = {
  dress_name: '',
  project_id: 0,
  speaker: '',
  model_id: 0,
  model_name: '',
  is_default: false,
};

// 의상 생성 DTO
export interface IDressCreate {
  dress_name: string;
  speaker: string;
  is_default: boolean;
  project_id: number;
}

export interface IDress {
  dress_id?: number;
  dress_name: string;
  project_id: number;
  speaker: string;
  model_id: number;
  model_name: string;
  is_default: boolean;
}

export interface IEpisodeLang {
  id?: number;
  lang: string;
  title: string;
  summary: string | null;
}

// * 에피소드 extenstion
export interface IEpisodeExtension {
  id?: number;
  banner_url: string | null;
  banner_key: string | null;
  bucket: string | null;
}

// * 에피소드 정보
export interface IEpisode {
  episode_id: number;
  project_id: number;
  episode_type: string;
  title: string;
  episode_status: string;
  ending_type: string;
  unlock_style: string;
  unlock_by: string | null;
  depend_episode: number;
  chapter_number: number;
  speaker: string | null;

  dlc_id: number;
  details: IEpisodeLang[];
  extension: IEpisodeExtension | null;
  indexed_title: string;
}

export const EmptyProject: IProject = {
  project_id: 0,
  project_type: '',
  default_lang: '',
  project_state: '',
  title: '',
  sortkey: 0,
  bubble_set_id: 0,
  produce_package_id: '',
  bundle_id: '',
  prime_currency_text_id: 0,
  projectDetails: [],
  langs: [],
  icon_url: '',
};

// * 프로젝트 마스터정보 Kevin
export interface IProject {
  project_id: number;
  project_type: string;
  default_lang: string;
  project_state: string;
  title: string;
  sortkey: number;
  bubble_set_id: number;
  produce_package_id: string | null;
  bundle_id: string | null;
  prime_currency_text_id: number;
  projectDetails: IProjectDetail[];
  langs: IProductLang[];
  icon_url: string | null;
  organizationName?: string;
}

// * 프로젝트 상세정보 kevin
export interface IProjectDetail {
  id?: number;
  lang: string;
  title: string;
  summary: string | null;
  writer: string | null;
  icon_url: string | null;
  icon_key: string | null;
  icon_bucket: string | null;
  original: string | null;
  translator: string | null;
}

export interface IProductLang {
  lang: string;
  title: string;
  banner_url: string | '';
  banner_key: string | '';
  bucket: string | '';
  price: number | null;
}

export interface IStringCodeQueryResult {
  isLoading: boolean;
  isError: boolean;
  data: ICommonCode[];
}

export interface INumberCodeQueryResult {
  isLoading: boolean;
  isError: boolean;
  data: INumberCode[];
}

// * 기본 코드 값
export interface ICommonCode {
  code: string;
  code_name: string;
}

export interface INumberCode {
  code: number;
  code_name: string;
}
export interface IStandardStore {
  bubbleSet: IBubbleSet[];
  supportLang: ICommonCode[];
  primeCurrency: ICommonCode[];
  projectType: ICommonCode[];
  appLang: ICommonCode[];
}

// 스태틱 이미지 리소스 extension
export interface IStaticExtension {
  id: number;
  thumbnail_url: string | null;
  thumbnail_key: string | null;
  bucket: string | null;
  appear_episode: number;
}

// 일반 로컬라이제이션 개체
export interface ICommonLocalization {
  id: number;
  lang: string | null;
  public_name: string | null;
  summary: string | null;
}

// 배경, 미니컷, 이미지 일러스트
export interface IStaticImage {
  id: number;
  project_id: number; // 연결 프로젝트 ID
  image_type: string;
  image_name: string;
  image_url: string;
  image_key: string;
  bucket: string;
  offset_x: number;
  offset_y: number;
  sortkey: number;
  is_public: boolean; // 공개 여부(앨범, 메모리 등)
  speaker: string | null; // 연관 등장인물 이름
  game_scale: number;

  extension: IStaticExtension[] | null;
  localizations: ICommonLocalization[] | null;
}

export interface IBubbleSetProps {
  big_font_size: number;
  bubble_type: string;
  bubble_ver: number;
  line_space: number;
  normal_font_size: number;
  remark: number;
  set_id: number;
  set_name: string;
  sortkey: number;
  tag_align_type: string;
  tag_color_affect: number;
  tag_textarea_bottom: number;
  tag_textarea_left: number;
  tag_textarea_right: number;
  tag_textarea_top: number;
}
export interface IEpisodeProps {
  episode_id: number;
  project_id: number;
  episode_type: string;
  title: string;
  summary: null;
  lang_exists: number;
  episode_status: number;
  currency: string;
  ending_type: string;
  depend_episode: number;
  depend_episode_title: string;
  unlock_style: string;
  // unlock_episodes: null;
  // unlock_scenes: null;
  // unlock_coupon: null;
  price: number;
  sale_price: number;
  one_currency: string;
  one_price: number;
  sortkey: number;
  square_image_id: number;
  title_image_url: string;
  title_image_key: string;
  popup_image_id: number;
  popup_image_url: string;
  popup_image_key: string;
  first_reward_currency: string;
  first_reward_quantity: number;
  first_reward_exp: number;
  selection_check: number;
  publish_date: string;
  next_open_min: number;
  open_decrease_rate: number;
  indexed_title: string;
}

// 능력 이름 Localization
export interface IAbilityLocalization {
  id?: number;
  lang: string;
  ability_name: string;
  updated?: boolean;
}

// 능력(2023.12.18)
export interface IAbility {
  ability_id?: number;
  ability_name: string;
  icon_url: string | null;
  icon_key: string | null;
  bucket: string | null;
  is_main: boolean;
  max_value: number;
  gift_limit_value: number;
  profile_id: number;
  localizations: IAbilityLocalization[];
}

export interface IMissionDetailProps {
  mission_id: number; //작품id
  mission_name: string; //작품명
  unlock_check: number; //미션 건수
  open_date: number; //해금 건수
  reward_date: number; //보상 획득 건수
}
export interface IMissionProps {
  project_id: number; //작품id
  project_name: string; //작품명
  mission_total: number; //미션 건수
  user_total: number; //해금 건수
  user_reward: number; //보상 획득 건수
  last_mission_date: string;
}

export interface IDLCLocalProps {
  lang: string;
  dlc_title: string;
  dlc_summary: string;
  code?: string;
  code_name?: string | undefined | null;
  key?: number | string | undefined;
  banner_id: number;
  banner_url?: string | undefined;
  banner_key?: string | undefined;
}
export interface IDLCDetailProps {
  cast1: string;
  cast2: string;
  cast3: string;
  cast4: string;
  dlc_id: number;
  dlc_name: string;
  dlc_type: string;
  price: number;
  project_id: number;
  sale_price: number;
}

// AppContext 용도
export interface AppContextValue {
  standards: IStandardStore | null;
  logStandardsInfo: () => void;
  updateStandards: (data: IStandardStore | null) => void;
}

export interface IBubbleSet {
  code: number;
  code_name: string;
}
export interface IProjectType {
  standard_id: number;
  code: string;
  code_name: string;
}
export interface IPrimeCurrency {
  code: string;
  code_name: string;
}

export interface ISupportLanguage {
  standard_id?: number;
  code: string;
  code_name: string;
}

export interface ICreateStory {
  project_type: string;
  default_lang: string;
  title: string;
}

export interface IUpdateStory {
  // project_type: string;
  // default_lang: string;
  // bubble_set_id: any;
  // prime_currency_text_id: any;
  id?: number | null;
  lang?: string;
  title?: string;
  summary?: any;
  writer?: string;
  icon_url?: string | null;
  icon_key?: string | null;
  original?: string;
  translator?: any;
}

export interface IEpisodesDetail {
  episode_id: number;
  project_id: number;
  episode_type: string;
  title: string;
  episode_status: string;
  ending_type: string;
  unlock_style: string;
  unlock_by: any;
  depend_episode: number;
  chapter_number: number;
  speaker: any;
  dlc_id: number;
  details: IDetail[];
  extension: IExtension;
  indexed_title: string;
}

export interface IDetail {
  id: number | null;
  lang: string;
  title: string;
  summary: string;
}

export interface IExtension {
  id: number;
  banner_url: string;
  banner_key: string;
  bucket: string;
}
